
// Import utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import definitions
import { getIntegration } from '@automator/builder/definitions/integrations';

/**
 * Retrieves the directory data of a specific universal token
 *
 * @param {String} integrationCode The integration code. E.g. `DATETIME`.
 * @param {String} tokenCode The token base. E.g. `POSTMETA`.
 * @return {Object} The universal token data.
 */
const getUniversalToken = ( integrationCode, tokenCode ) => {
	// Check if the integration code is valid
	if ( isEmpty( integrationCode ) ) {
		throw new Error( `directory/getUniversalToken: The integration code must be defined` );
	}

	// Check if the token code is valid
	if ( isEmpty( tokenCode ) ) {
		throw new Error( `directory/getUniversalToken: The token code must be defined` );
	}

	// Get the integration
	const integration = getIntegration( integrationCode );

	// Check if the integration is valid
	if ( isEmpty( integration ) ) {
		throw new Error( `directory/getUniversalToken: The integration with the code "${ integrationCode }" does not exist` );
	}

	// Get the token
	const token = integration.tokens.find( token => token.id === `UT:${ integrationCode }:${ tokenCode }` );

	// Check if the token is valid
	if ( isEmpty( token ) ) {
		throw new Error( `directory/getUniversalToken: The token with the code "${ tokenCode }" does not exist` );
	}

	return token;
}

export default getUniversalToken;
